module.exports = __webpack_public_path__ + "img/lw-exp3.589151d2.jpg";